import axios from "axios";
import { ORG_PROFILE } from "../../constant/API constant";

export const Profile_Api = () => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${ORG_PROFILE}`, {
    headers: { Authorization: jwt_token },
  });
};
